module.exports = __webpack_public_path__ + "static/Graphik-Black-Web-377a11cf4a5ab410711d85a1860f2ed6.woff";